<template>
    <div
        v-if="showOneClickBlock"
        class="mt-[24px] flex items-center justify-between rounded-[10px] border border-[#FFD5A5] bg-[#FFF4E5] px-[18px] py-[17px]"
    >
        <div>
            <p
                class="text-[12.25px] font-medium leading-[142%]"
                style="color: #744210"
            >
                {{ $t("vue.one_click_dns_setup_available") }}
            </p>
            <p
                class="mt-1 w-auto text-[10.5px] leading-[142%]"
                :class="
                    userSourceDestination === 'wizard'
                        ? 'max-w-[415px]'
                        : 'max-w-[630px]'
                "
                style="color: #744210"
            >
                {{
                    $t("vue.one_click_dns_setup_description", {
                        provider: detectedDnsProvider,
                    })
                }}
            </p>
        </div>

        <button
            type="button"
            :disabled="submitting"
            class="inline-flex h-[28px] cursor-pointer items-center justify-center gap-[3.65px] rounded-[6px] bg-gradient-to-r from-[#FF6B00] to-[#FF8E01] px-[14px] text-[10.5px] font-medium leading-[140%] text-white disabled:opacity-60"
            @click="apply"
        >
            <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <g clip-path="url(#clip0_6163_15526)">
                    <path
                        d="M15.3638 9.20228L13.2931 8.01493L12.936 7.86047L4.46509 7.91838V12.219H15.3638V9.20228Z"
                        fill="#FF7101"
                    />
                    <path
                        d="M11.5939 11.8232C11.6952 11.4756 11.6566 11.1572 11.4876 10.9206C11.3332 10.7035 11.0726 10.578 10.7587 10.5635L4.81711 10.4863C4.77846 10.4863 4.74473 10.4671 4.72534 10.4381C4.70595 10.4092 4.70116 10.3705 4.71086 10.3319C4.73012 10.274 4.78802 10.2305 4.85084 10.2256L10.8456 10.1484C11.5551 10.1147 12.3274 9.5403 12.5977 8.8356L12.9403 7.9427C12.9548 7.90405 12.9596 7.86554 12.95 7.82689C12.5641 6.07934 11.0051 4.77618 9.14202 4.77618C7.42369 4.77618 5.96607 5.88636 5.44478 7.42606C5.09136 7.16287 4.65259 7.04071 4.21401 7.0834C3.38858 7.16548 2.72744 7.82675 2.64536 8.65205C2.6261 8.86442 2.64058 9.072 2.68879 9.26498C1.34194 9.30363 0.265625 10.4041 0.265625 11.7604C0.265625 11.8811 0.27532 12.0017 0.289797 12.1224C0.293951 12.1503 0.307878 12.1758 0.329092 12.1944C0.350305 12.2129 0.377425 12.2234 0.405609 12.2238H11.3719C11.4346 12.2238 11.4927 12.1803 11.5119 12.1175L11.5939 11.8232Z"
                        fill="white"
                    />
                    <path
                        d="M13.4833 8.00537C13.4301 8.00537 13.3722 8.00537 13.3191 8.01015C13.2805 8.01015 13.2467 8.03911 13.2322 8.07775L13.0006 8.88379C12.8993 9.23136 12.9379 9.54985 13.1069 9.78639C13.2613 10.0035 13.5219 10.129 13.8357 10.1435L15.1004 10.2207C15.139 10.2207 15.1728 10.2399 15.1922 10.2689C15.2114 10.2978 15.2163 10.3413 15.2066 10.3751C15.1874 10.4331 15.1295 10.4765 15.0666 10.4814L13.7486 10.5587C13.0342 10.5924 12.2668 11.1668 11.9966 11.8715L11.9 12.1176C11.8807 12.1659 11.9145 12.2142 11.9676 12.2142H16.495C16.5482 12.2142 16.5964 12.1805 16.6109 12.1273C16.688 11.8474 16.7316 11.5529 16.7316 11.2489C16.7316 9.46299 15.274 8.00537 13.4833 8.00537Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_6163_15526">
                        <rect width="17" height="17" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            {{ $t("vue.configure_with_cloudflare") }}
            <svg
                width="9"
                height="9"
                viewBox="0 0 9 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <g clip-path="url(#clip0_6163_15531)">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.875 0.75H2.625C2.83211 0.75 3 0.917893 3 1.125C3 1.31731 2.85523 1.47582 2.66873 1.49748L2.625 1.5H1.875C1.68269 1.5 1.52418 1.64476 1.50252 1.83127L1.5 1.875V7.125C1.5 7.31731 1.64476 7.47581 1.83127 7.49748L1.875 7.5H7.125C7.31731 7.5 7.47581 7.35523 7.49748 7.16873L7.5 7.125V6.375C7.5 6.16789 7.66789 6 7.875 6C8.06731 6 8.22581 6.14476 8.24748 6.33127L8.25 6.375V7.125C8.25 7.72413 7.78165 8.21387 7.1911 8.24809L7.125 8.25H1.875C1.27587 8.25 0.786127 7.78165 0.75191 7.1911L0.75 7.125V1.875C0.75 1.27587 1.21834 0.786127 1.8089 0.75191L1.875 0.75ZM7.875 0.75L7.90537 0.751125L7.95027 0.75759L7.99205 0.768652L8.03371 0.785128L8.07026 0.804748L8.10628 0.829795L8.14016 0.859835L8.17637 0.90176L8.20325 0.943477L8.21488 0.966338L8.22754 0.996881L8.23656 1.02525L8.24741 1.08071L8.25 1.125V3.375C8.25 3.58211 8.08211 3.75 7.875 3.75C7.66789 3.75 7.5 3.58211 7.5 3.375V2.03025L5.14016 4.39016C5.00498 4.52535 4.79227 4.53574 4.64516 4.42136L4.60983 4.39016C4.47465 4.25498 4.46425 4.04227 4.57864 3.89516L4.60983 3.85983L6.969 1.5H5.625C5.41789 1.5 5.25 1.33211 5.25 1.125C5.25 0.917893 5.41789 0.75 5.625 0.75H7.875Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_6163_15531">
                        <rect width="9" height="9" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </button>
    </div>
</template>

<script setup lang="ts">
import { useDomainConnectApply } from "@/composables/useDomainConnectApply";

const props = defineProps({
    showOneClickBlock: { type: Boolean, default: true },
    detectedDnsProvider: { type: String, default: "Cloudflare" },

    domainName: { type: String, required: true },
    desiredDmarcRecord: { type: String, required: true },
    userSourceDestination: { type: String, default: "wizard" },
});

const { apply, submitting } = useDomainConnectApply(
    () => props.domainName,
    () => props.desiredDmarcRecord,
    () => props.userSourceDestination,
);
</script>

<style scoped></style>
